import { AbstractControl, AsyncValidatorFn, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Observable, timer, of } from 'rxjs';
import { map, first } from 'rxjs/operators';

export class AsyncValidators {
  /**
   * Wraps a synchronous validator with a debounce timer.
   * @param validator The sync ValidatorFn to execute
   * @param debounceMs Delay in milliseconds
   */
  static debounce(validator: ValidatorFn, debounceMs: number = 500): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      if (!control.value) return of(null);

      return timer(debounceMs).pipe(
        map(() => validator(control)),
        first()
      );
    };
  }
}